import { Component } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector: 'app-bienvenue-sans-acces',
    templateUrl: './bienvenue-sans-acces.component.html',
    styleUrls: ['./bienvenue-sans-acces.component.scss'],
    imports: [
        TranslateModule
    ]
})
export class BienvenueSansAccesComponent {

}
